import React, { useState } from "react";
import { useQuery, useLazyQuery } from "react-apollo";
import { QUERY, GET_ADMISSION } from "../../../queries/patient.query";
import { SaveData } from "../../../providers/Patient.Provider";
import { toast } from "react-toastify";
import { CleanMessage } from "../../../util/app";
import LoadingSpinner from "../../../partials/loading";
import AllergyList from "../partial/AllergyList";
import NextOfKinInformation from "./Components/NextOfKinInformation";
import PatientGPInformation from "./Components/PatientGPInformation";
import PatientRiskInformation from "./Components/PatientRiskInformation";
import PatientAdmission from "../partial/AdmissionCard";
import PatientHistory from "./Components/PatientHistory";
import PatientRejection from "./Components/PatientRejection ";
import PatientInterest from "./Components/PatientInterest";
import PatientReferral from "./Components/PatientReferral ";
import { NavLink } from "react-router-dom";
import AuthProvider from "../../../providers/Auth.Provider";
import { EventEmitter } from "../../../event/EventEmitter";
import { EVENT_TARGET } from "../../../event/model";

const PatientSummary = ({ match }) => {
    const { admin } = AuthProvider.authProvider.GetAuthenticatedStaff();

    const { id } = match.params;
    const [patient, setPatient] = useState();
    const [admission, setAdmission] = useState();

    //   Get Patient information
    const { loading } = useQuery(QUERY.GETPATIENT, {
        variables: { id },
        onCompleted: (data) => {
            const { doc } = data.GetPatient;
            SaveData(doc);
            setPatient(doc);

            if (doc.lastAdmission)
                getAdmissionFunc({
                    variables: { admission: doc.lastAdmission },
                });
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    // Get patient admission
    const [getAdmissionFunc, { loading: aLoading }] = useLazyQuery(GET_ADMISSION, {
        onCompleted: (data) => {
            setAdmission(data.GetAdmission.doc);
        },
        onError: (e) => toast.error(CleanMessage(e.message)),
    });
    EventEmitter.subscribe(EVENT_TARGET.Admit, async (event) => await getAdmissionFunc({ variables: { admission: event.lastAdmission } }));
    return (
        <>
            <LoadingSpinner loading={loading || aLoading} bar={true} />
            {patient && (
                <>
                    <div className="row fade-in">
                        <div className="col-lg-4">
                            <PatientHistory isAdmin={admin} id={id} item={patient.history} />
                        </div>
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-head">
                                            <header>Risk</header>
                                        </div>
                                        <div className="card-body small-card">
                                            <PatientRiskInformation isAdmin={admin} item={id} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-head">
                                            <header>Allergies</header>
                                        </div>
                                        <div className="card-body" style={{ minHeight: "60px" }}>
                                            <AllergyList items={patient.allergies} id={id} />
                                        </div>
                                        {admin && (
                                            <div className="card-footer text-right">
                                                <NavLink
                                                    to={{
                                                        pathname: `/home/patient/profile/${id}/update-allergy`,
                                                        search: `?ref=${id}`,
                                                    }}
                                                    className="mdl-button mdl-js-button mdl-button--fab fab-mini"
                                                >
                                                    <i className="material-icons text-success">add</i>
                                                </NavLink>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <PatientInterest isAdmin={admin} interests={patient.interest} id={id} />
                        </div>
                    </div>
                    <div className="row fade-in">
                        <div className="col-lg-4">
                            <PatientGPInformation id={id} isAdmin={admin} item={patient.gp} />
                        </div>
                        <div className="col-lg-4">
                            <div className="card">
                                <div className="card-head">
                                    <header>Next of Kin</header>
                                </div>
                                <div className="card-body min-card">
                                    <NextOfKinInformation isAdmin={admin} item={patient} />
                                </div>
                                <div className="card-footer m-4"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="card">
                                <div className="card-head">
                                    <header>Admission Detail</header>
                                </div>
                                <div className="card-body min-card">
                                    <PatientAdmission item={admission} />
                                </div>
                                <div className="card-footer m-4"></div>
                            </div>
                        </div>
                    </div>
                    <div className="row fade-in">
                        <div className="col-lg-6">
                            <PatientReferral isAdmin={admin} id={id} referral={patient.referral} />
                        </div>
                        <div className="col-lg-6">
                            <PatientRejection isAdmin={admin} id={id} rejection={patient.rejection} />
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default PatientSummary;
